import { ClubsService } from './../../clubs/clubs.service';
import { Component, Injector } from '@angular/core';
import { Validators } from '@angular/forms';
import { REGEX } from 'src/app/app.validators';
import { Club } from '../../clubs/club.model';
import { Quote } from '../quote.model';
import { BaseFormComponent } from 'src/app/shared/components/base-form-component/base-form-component';
import { QuotesService } from '../quotes.service';

@Component({
    selector: 'ng-quotes',
    templateUrl: 'quotes-form.component.html'
})

export class QuotesFormComponent extends BaseFormComponent<Quote>{
   
    public clubs:Array<Club>;
    public isThereCitiesInLocalStorage:boolean;

    constructor(protected injector: Injector,protected quotesServ:QuotesService,public  clubsServ:ClubsService) {
        super(injector,'quote','/admin/quotes',Quote.fromJsonToObject,quotesServ);
    }

    protected initChildMethods(): void {
        !!localStorage.getItem('clubs')?
        this.isThereCitiesInLocalStorage=true:
        this.isThereCitiesInLocalStorage=false

        if(this.isThereCitiesInLocalStorage){
            this.clubs=this.clubsServ.buildArrayOfObjects(JSON.parse(localStorage.getItem("clubs")));
            return;
        }

        this.formSubscription.add(this.clubsServ.getAll().subscribe(clubs => {
            this.clubs=clubs
            this.saveInLocalStorage(clubs)
        }))
    }

    private saveInLocalStorage(clubs:Array<Club>) {
        localStorage.setItem('clubs',JSON.stringify(clubs))
    }

    protected buildForm(): void {

        this.objectForm=this.formBuilder.group({

            quota_description:this.formBuilder.control(null,[Validators.required]),

            quota_value:this.formBuilder.control(null,[
                Validators.required,
                Validators.minLength(1),
                Validators.pattern(REGEX.numberPatternNoComma)
            ]),
            payment_date:this.formBuilder.control(null,[
                Validators.required,
                Validators.minLength(1),
                Validators.pattern(REGEX.numberPatternNoComma)
            ]),

            clubs_id:this.formBuilder.control(null,[Validators.required]),

            periods_id:this.formBuilder.control(null,[Validators.required]),

            id:[null]
        })
    }

    protected initChildProprieties(): void {
        this.isThereCitiesInLocalStorage=false;
    }

    

}